import type { Organization } from "../../domain/organizations/organization.types";
import type { Language, LocalizedText } from "../../domain/shared/localized-text.types";
import type { InstitutionalPageData } from "./institutionalPage.types";

const localize = (value: LocalizedText | undefined, language: Language): string | undefined =>
  value?.[language] ?? value?.es;

const firstNonEmpty = (values?: string[]): string | undefined =>
  values?.find((value) => value.trim());

export const mapInstitutionalOrganizationToPage = (
  organization: Organization,
  language: Language
): InstitutionalPageData => ({
  id: organization.id,
  name: localize(organization.identity.name, language) ?? "",
  slogan: localize(organization.identity.summary, language) ?? "",
  description: localize(organization.identity.description, language) ?? "",
  history: localize(organization.institutional?.history, language) ?? "",
  mission: localize(organization.institutional?.mission, language) ?? "",
  vision: localize(organization.institutional?.vision, language) ?? "",
  logo: organization.identity.logo?.src ?? "",
  galleryImages: (organization.media?.images ?? []).map((image, index) => ({
    url: image.src,
    name: `${localize(organization.identity.name, language) ?? organization.id} ${index + 1}`,
    caption: localize(image.caption, language),
  })),
  contactInfo: {
    address:
      localize(organization.contact?.address, language) ??
      localize(organization.location?.address, language),
    phone: firstNonEmpty(organization.contact?.phones),
    email: firstNonEmpty(organization.contact?.emails),
  },
  socialMedia: organization.contact?.social ?? {},
  location: organization.location?.coordinates
    ? {
        lat: organization.location.coordinates.latitude,
        lng: organization.location.coordinates.longitude,
      }
    : undefined,
});
